export enum AssetContainerEventType {
  Arrived = 'Arrived',
  Loading = 'Loading',
  LoadingComplete = 'Loading Complete',
  Unloading = 'Unloading',
  UnloadingComplete = 'Unloading Complete',
  ReadyForPickup = 'Ready for Pickup',
  Departed = 'Departed',
  Inoperable = 'Inoperable',
  Missing = 'Missing'
}

export interface IAssetContainerEvent {
  id: string;
  createDateTime: Date;
  createdBy?: string | null;
  orgId: string;
  assetContainerId: string;
  assetVisitId?: string | null;
  eventType: AssetContainerEventType;
}
